<div class="container">
	<div class="row">
		<div class="col-lg-12">
			<div class="item-panel">
				<div class="heading">Fleetwide operations</div>
				<div class="content">
					<div *ngIf="!allAssets" class="text-center pt-3 pb-3">
						<div class="logo-spin light"></div>
						Loading...
					</div>
					<div class="row">
						<div class="col-lg-12">
							<div *ngIf="allAssets">
								<ul ngbNav #navAll="ngbNav" class="nav-tabs">
									<li ngbNavItem>
										<a ngbNavLink>Asset Logins</a>
										<ng-template ngbNavContent>
											<app-manage-all-asset-logins [assets]="allAssets"></app-manage-all-asset-logins>
										</ng-template>
									</li>
									<li ngbNavItem>
										<a ngbNavLink>User Logins</a>
										<ng-template ngbNavContent>
											<app-manage-all-user-logins></app-manage-all-user-logins>
										</ng-template>
									</li>
									<li ngbNavItem>
										<a ngbNavLink>Firmware</a>
										<ng-template ngbNavContent>
											<app-manage-all-firmware></app-manage-all-firmware>
										</ng-template>
									</li>
									<li ngbNavItem>
										<a ngbNavLink>Sent Emails</a>
										<ng-template ngbNavContent>
											<app-manage-sent-email></app-manage-sent-email>
										</ng-template>
									</li>
								</ul>
								<div [ngbNavOutlet]="navAll">Nav goes here</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>